import { useRequestInfo } from './useRequestInfo'

/**
 * @returns the user's theme preference, or 'light' if no preference is set
 */
export function useTheme(): 'light' | 'dark' {
	const requestInfo = useRequestInfo()
	return requestInfo.userPrefs.theme ?? 'dark'
}
